
  import { Component, Prop, Mixins } from 'vue-property-decorator';

  import ReviewClose from '@/components/reviews/common/review-close.vue';
  import ReviewStatusHistory from '@/components/reviews/common/review-status-history.vue';
  import { Review } from '@/types/review';
  import ManageMixin from '@/mixins/reviews/common/manage';

  @Component({
    components: {
      ReviewClose,
      ReviewStatusHistory,
    },
  })
  export default class ReviewListManage extends Mixins<ManageMixin>(ManageMixin) {
    @Prop() review!: Review;

    private get permissions() {
      return this.review.permissions;
    }
  }
